import React, { useEffect, useRef, useState } from "react";
// styled components
import { Button, Modal, Form, Input, Select } from "antd";
// models
import {
  DocumentosGeneralesModel,
  initialValuesDocumentosGeneralesModel,
} from "../../../../models/DocumentosModel/documentosGenerales.model";
// savefile
import { saveFile } from "../../../../utils/saveFile";
import { useMaestras } from "../../../../hooks/useMaestras";
import DocumentInput from "../../../../utils/DocumentInput";
import { openNotification } from "../../../../utils/Notifactions";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  documento: DocumentosGeneralesModel;
  setDocumento: any;
  documentos: Array<DocumentosGeneralesModel>;
  setDocumentos: any;
  indexdocumento: number;
}

export const ModalEditarDocumentacionGeneral: React.FC<IProps> = (
  props: IProps
) => {
  const [guardoArchivo, setGuardoArchivo] = useState(true);

  const { documentosGenerales, obtenerDocGen } = useMaestras();

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      obtenerDocGen();
    }
    return () => {
      mounted = false;
    };
  }, []);

  const fileInputRef = useRef<any>();
  //  functions
  const editarFila = () => {
    if (!guardoArchivo) {
      return openNotification({
        titulo: "Error",
        descripcion: "No puedes agregar sin adjuntar un archivo",
        placement: "bottomRight",
      });
    }

    let infoupdate = [...props.documentos];
    infoupdate[props.indexdocumento] = props.documento;
    props.setDocumentos(infoupdate);
    props.setVisualizar(false);
    return props.setDocumento(initialValuesDocumentosGeneralesModel);
  };
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      let archivo = e.target.files[0];
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      const data = await saveFile(e);
      if (
        archivo.type === "application/pdf" ||
        archivo.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        archivo.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        archivo.type === "image/png" ||
        archivo.type === "image/jpeg"
      ) {
        setGuardoArchivo(true);
        return props.setDocumento({
          ...props.documento,
          url_documento: data.data,
        });
      }
    }
  };
  // fields
  const fields = [
    { name: "nombre", value: props.documento.nombre },
    { name: "tipo_documento", value: props.documento.tipo_documento },
    { name: "descripcion", value: props.documento.descripcion },
    { name: "url_documento", value: props.documento.url_documento },
  ];
  return (
    <Modal
      title="Editar documentación general"
      visible={props.visualizar}
      onCancel={() => {
        props.setDocumento(initialValuesDocumentosGeneralesModel);
        props.setVisualizar(false);
      }}
      width={1200}
      footer={[
        <Button key="b_cerrar_modal_docu_gene"
          className="button-gray-ghost"
          onClick={() => {
            props.setDocumento(initialValuesDocumentosGeneralesModel);
            setGuardoArchivo(true);
            props.setVisualizar(false);
          }}
        >
          Cerrar
        </Button>,
        <Button key="b_guardar_modal_docu_gene"
          className="button-azul-radius"
          htmlType="submit"
          form="documentosconvocatoriaeditardocumentosbeps"
        >
          Guardar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="container-fluid">
        <div className="row">
          <Form
            name="documentosconvocatoriaeditardocumentosbeps"
            size="large"
            layout="vertical"
            className="width-100"
            onFinish={() => {
              editarFila();
            }}
            fields={fields}
            onFieldsChange={(_, fields: any) => {
              let infoupdate: any = { ...props.documento };
              for (const i in fields) {
                infoupdate[fields[i].name] = fields[i].value;
              }
              props.setDocumento(infoupdate);
            }}
          >
            <div className="row">
              <div className="col-12 col-md-3">
                <Form.Item
                  className="no-margin"
                  label="Nombre"
                  name="nombre"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="col-12 col-md-3">
                <Form.Item
                  className="no-margin"
                  label="Tipo de documento"
                  name="tipo_documento"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Select placeholder="Seleccionar..">
                    {documentosGenerales.map(({ id, nombre }: any) => (
                      <Select.Option key={id} value={nombre}>
                        {nombre}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-12 col-md-6">
                <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353 mt-1">
                  Adjuntar documento
                </span>
                <DocumentInput
                  doc={props.documento.url_documento}
                  fileInputRef={fileInputRef}
                  tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                  setGuardoArchivo={setGuardoArchivo}
                  on_change={(e) => {
                    setGuardoArchivo(true);
                    guardarArchivo(e);
                    e.target.value = "";
                  }}
                  onDelete={() =>
                    props.setDocumento({
                      ...props.documento,
                      url_documento: "",
                    })
                  }
                />
              </div>
              <div className="col-12">
                <Form.Item
                  label="Descripción"
                  name="descripcion"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Input.TextArea showCount={true} maxLength={300} />
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};
